import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import { IRichTextInformation } from "@bond-london/graphcms-rich-text";
import classNames from "classnames";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import { Trans } from "react-i18next";
import { DashedText } from "../elements/DashedText";
import { RTF } from "../elements/RTF";

export const PageLink: React.FC<{
  className?: string;
  image?: IGatsbyImageData | null;
  alt?: string | null;
  title?: string | null;
  heading?: string | null;
  message?: IRichTextInformation | null;
  link?: string | null;
  linkTitle?: string | null;
}> = ({ alt, image, title, heading, message, link, linkTitle, className }) => {
  return (
    <section
      data-component="Page Link"
      className={classNames(className, "py-section")}
    >
      {heading && (
        <h2 className="h2 col-span-4 col-start-2 md:col-span-6 md:col-start-3 lg:col-span-14 lg:col-start-3">
          {heading}
        </h2>
      )}
      {title && (
        <h3 className="h6 col-span-4 col-start-2 text-hyacinth md:col-span-6 md:col-start-3 lg:col-start-3">
          {title}
        </h3>
      )}
      {image && (
        <div
          className={classNames(
            "col-span-14 col-start-2 mb-30px lg:mb-60px",
            "aspect-h-650 aspect-w-1440",
            "mt-20px lg:mt-40px"
          )}
        >
          <GatsbyImage
            style={{ position: "absolute" }}
            objectFit="cover"
            objectPosition="center"
            image={image}
            alt={alt ?? title ?? "Image"}
            loading="lazy"
          />
        </div>
      )}
      {message && (
        <RTF
          className="text-right-margin col-span-4 col-start-2 mt-20px lg:col-span-8 lg:col-start-7 lg:mt-0"
          fixedParagraphClassName="p1"
          content={message}
        />
      )}
      {link && (
        <Link
          className="h6 text-right-margin p4 read-more col-span-4 col-start-2 mt-20px flex text-hyacinth md:col-span-6 md:col-start-3 lg:col-start-3"
          to={link}
          aria-label={linkTitle ? linkTitle : "Discover more"}
        >
          <DashedText colorClassName="text-hyacinth flex">
            {linkTitle ?? <Trans>Discover more</Trans>}
          </DashedText>
        </Link>
      )}
    </section>
  );
};
